@for (image of court().images; let i = $index; track i) {
  @if (!imageLoaded[i]) {
    <app-ccs-skeleton height="65px" width="65px" radius="full" />
  }

  <img
    [src]="image.file"
    [alt]="image.name"
    class="size-16 rounded-full object-cover"
    [class.hidden]="!imageLoaded[i]"
    (load)="imageLoaded[i] = true" />
}
